import React from 'react'
import "./CountTag.scss"

const CountTag = ({count}) => {
  return (
    <span className="predict-select-tag-count">{count}</span>
  )
}

export default CountTag;